import { render } from "./ConfirmationOpenEnrollmentBenefit.vue?vue&type=template&id=7059f3d7&ts=true"
import script from "./ConfirmationOpenEnrollmentBenefit.vue?vue&type=script&lang=ts"
export * from "./ConfirmationOpenEnrollmentBenefit.vue?vue&type=script&lang=ts"

import "./ConfirmationOpenEnrollmentBenefit.vue?vue&type=style&index=0&id=7059f3d7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__